<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose">
    <el-row>
      <el-col :span="12"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;">
          <span style="color: red;margin-right: 5px;">*</span>
          <label for="">课件名称：</label>
          <span>{{name}}</span>
        </div>
      </div>
      </el-col>
      <!--        <el-col :span="12"><div class="grid-content bg-purple-dark">-->
      <!--          <div style="font-size: 12px;">-->
      <!--            <span style="color: red;margin-right: 5px;">*</span>-->
      <!--            <label for="">课件代码：</label>-->
      <!--            <span>HXE-ER09</span>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        </el-col>-->
    </el-row>
    <el-row>
      <el-col :span="12"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;">
          <label for="">课件类别：</label>
          <span>{{typeName}}</span>

        </div>
      </div>
      </el-col>
      <el-col :span="12"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;">
          <span style="color: red;margin-right: 5px;">*</span>
          <label for="">讲课老师：</label>
          <span>{{teacher}}</span>
        </div>
      </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;">
          <span style="color: red;margin-right: 5px;"></span>
          <label for="">知识点：</label>
          <span>{{knowLeg}}</span>
        </div>
      </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;">
          <span style="color: red;margin-right: 5px;">*</span>
          <label for="">上传人：</label>
          <span>{{uname}}</span>
        </div>
      </div>
      </el-col>
      <el-col :span="12"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;">
          <span style="color: red;margin-right: 5px;">*</span>
          <label for="">上传时间：</label>
          <span>{{datetime}}</span>
        </div>
      </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;">
          <span style="color: red;margin-right: 5px;vertical-align: top;">*</span>
          <label for="" style="vertical-align: top;">推送机构：</label>
          <span style="display: inline-block;width: 90%;">{{pushCompany}}</span>
        </div>
      </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;line-height: 40px;">
          <label for="">引用量：</label>
          <span>{{cites}}</span>
        </div>
      </div>
      </el-col>
      <el-col :span="12"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;line-height: 40px;display: inline-block">
          <label for="">状态：</label>
          <span v-if="status =='0'" style="color: red;">禁用</span>
          <span v-if="status =='1'">
                 <span v-if="wareStatus =='0'">审核中</span>
                 <span v-if="wareStatus =='1'" style="color: green;">正常</span>
                 <span v-if="wareStatus =='2'" style="color: red;">退回</span>
               </span>
        </div>
        <el-button type="primary" style="margin-left: 10px;" v-if="checkBack" @click="back">查 看</el-button>
      </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;line-height: 40px;">
          <label for="">更新时间：</label>
          <span>{{ updateTime }}</span>
        </div>
      </div>
      </el-col>
      <el-col :span="8"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;line-height: 40px;">
          <label for="">最后更新人：</label>
          <span>{{updateUser}}</span>
        </div>
      </div>
      </el-col>
      <el-col :span="8"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;">
          <label for="">更新次数：</label>
          <span>{{updateNum}}</span>
          <el-button type="primary" style="margin-left: 10px;" v-if="updataLog" @click="updataList">更新日志</el-button>
        </div>
      </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;">
          <span style="color: red;margin-right: 5px;">*</span>
          <label for="">课件类型：</label>
          <span v-if="kjType =='1'">视频</span>
          <span v-if="kjType =='2'">音频</span>
          <span v-if="kjType =='3'" >文本</span>
          <span v-if="kjType =='4'" >文档</span>
          <span v-if="kjType =='5'" >音视频链接</span>
        </div>
      </div>
      </el-col>
      <el-col :span="8"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;">
          <label for="">文件名称：</label>
          <span>{{ filesName }}</span>
        </div>
      </div>
      </el-col>
      <el-col :span="8"><div class="grid-content bg-purple-dark">
        <div style="font-size: 12px;" v-show="ifDuration">
          <label for="">时长：</label>
          <span>{{ durations }}</span>
        </div>
      </div>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer" style="display: inline-block;width: 100%;text-align: center;">

<!--        <el-button type="primary" @click="pass" v-if="type == '2'">通 过</el-button>-->
<!--        <el-button type="primary" @click="back" v-if="type == '2'">退 回</el-button>-->
        <el-button type="primary" @click="gotoEdit" v-if="type == '1'">修 改</el-button>
        <el-button @click="dialogVisible = false" v-if="type == '1'||type == '0'">返 回</el-button>
  </span>
  </el-dialog>



</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/checkCourseware'
export default {
  name: 'VerifyEdit',
  components: {

  },
  data () {
    return {
      ifDuration:false,
      durations:'',
      checkDialog:false,
      isEdit:true,
      checkBack:false,
      updataLog:false,
      updateTime: '',
      updateUser : 'xx',
      updateNum: '0',
      status: '',
      wareStatus:'',
      cites: '0',
      kjType: '11',
      filesName: 'xxx.mp4',
      pushCompany:'百度',
      datetime: "",
      title:'详情',
      dialogVisible: false,
      loading: false,
      courseType:[
        {value:'1',course:'全课程'},
        {value:'2',course:'重难点'},
        {value:'3',course:'考前串讲'},
        {value:'4',course:'真题讲解'},
      ],
      teacher:'',
      knowLeg:'1234',
      id:'',
      name:'',
      typeName:'',
      uname:'',
      type:'',
      updateId:'',
      backReason:'',
      gotoChangeID:'',
    }
  },
  methods: {
    updataList(){//更新日志
      this.dialogVisible = false
      this.$emit('gotoUpdata',this.gotoChangeID)
    },

    // 跳转课件修改
    gotoEdit(){
      this.dialogVisible = false
      this.$emit('gotoEdit',this.gotoChangeID)
    },


    back () {
      console.log(this.backReason);
      this.$confirm(this.backReason, '退回原因', {
        confirmButtonText: '修改课件',
        cancelButtonText: '确定',
      }).then(() => {
        this.dialogVisible = false
        this.$emit('gotoChangePage',this.gotoChangeID)
      }).catch(() => {

      });
    },



// 初始化
    init (id,wareStatus,returnReason) {
      console.log(id);
      this.backReason = returnReason
      if(wareStatus == '1'){//审核通过
        this.updataLog = true
        this.checkBack = false
        this.type = 1
      }else if(wareStatus == '2'){//退回
        this.updataLog = false
        this.checkBack = true
        this.type = 1
      }else if(wareStatus == '0'){//审核
        this.updataLog = false
        this.checkBack = false
        this.type = 0
      }
      this.id = id
      // console.log(this.id);
      this.dialogVisible = true
      this.getList()
    },

    // 秒转时分秒
    secondsFormat(value) {
      console.log(22);
      let h = Math.floor(value / 3600) < 10 ? '0'+Math.floor(value / 3600) : Math.floor(value / 3600);
      let m = Math.floor((value / 60 % 60)) < 10 ? '0' + Math.floor((value / 60 % 60)) : Math.floor((value / 60 % 60));
      let s = Math.floor((value % 60)) < 10 ? '0' + Math.floor((value % 60)) : Math.floor((value % 60));
      return value = h + ":" + m + ":" + s;
    },
    // 获取数据
    getList () {
      // console.log(this.$route.query.id);
//      this.loading = true
      api.getDetail({id:this.id,courseWareId:this.$route.query.id}).then(({ data }) => {
        data = data.data
        console.log(data)
        this.durations =this.secondsFormat(data.duration)
        this.gotoChangeID = data.id
        this.name = data.title
        this.cites = data.cites
        this.updateUser = data.updateName
        this.filesName = data.fileName
        this.typeName = data.typeName
        this.teacher = data.teacherName
        this.knowLeg = data.knowledgeName
        this.uname = data.uname
        this.pushCompany = data.mhNames
        this.status = data.status
        this.wareStatus = data.wareStatus
        this.updateTime = this.renderTime(data.updateTime)
        this.updateNum = data.updateCount
        this.kjType = data.type
        this.updateId = data.updateId
        this.datetime = this.formatDate2(data.ctime)
        console.log(data.type);

        if(data.type == '1' || data.type == '2' || data.type == '5'){
          this.ifDuration = true
        }else {
          this.ifDuration = false
        }
        if(data.type == '5'){
          this.filesName = data.videoAddress
        }
      })
    },

    formatDate2(cellValue) {
      if (cellValue == null || cellValue == "") return "";
      let date = new Date(parseInt(cellValue)*1000);//时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },

    // 标准时间转日期
    renderTime(date) {
      if(date == null || date == undefined || date == ''){
        return
      }else {
        var dates = new Date(date).toJSON();
        return new Date(+new Date(dates) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
      }
    },


    handleClose () {
      this.dialogVisible = false
    },


    getTime (time) {
      let date = new Date(time)
      let y = date.getFullYear()
      let m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      let d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      return y + '-' + m + '-' + d
    },



  },
  created () {
    // this.getList()
  },
  computed: {
    getUId () {
      return localStorage.getItem('uid') 
    }
  },
  filters: {

  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item{
  font-size: 12px;
}
/deep/.el-tabs__item{
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li{
  background-color: #E2E8F4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #265480;
}
</style>
<style>
.grid-content{
  min-height: 20px;
  line-height: 20px;
  margin: 10px 0;
}
</style>
